














































import { Component, Vue } from 'vue-property-decorator'
import { Order } from 'foodme-firestore-db'
import { orderStore } from '../store/order-store'

@Component
export default class OrderListPage extends Vue {
  selectedOrder = {} as Order;

  get orders () {
    return orderStore.orders
  }

  selectOrder (order: Order) {
    this.selectedOrder = order
  }
}
